import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { scroller } from "react-scroll";
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();


  const isHomePath = (path) => {
    return path === "/" || /^\/service-desc(\/|$)/.test(path);
  };

  const [mode, setMode] = useState(() => (isHomePath(window.location.pathname) ? "home" : "admin"));

  useEffect(() => {
    setMode(isHomePath(location.pathname) ? "home" : "admin");
  }, [location.pathname]);

  useEffect(() => {
    setMode(location.pathname === "/" ? "home" : "admin");
  }, [location.pathname]);

  const handleNavTo = (section) => {

    toggleSidebar(false);

    if (mode === "admin") {
      if (section === "my-services") {
        navigate("/services");
      } else if (section === "client-messages") {
        navigate("/messages");
      } else {
        navigate("/services");
      }
      return;
    }

    if (location.pathname === "/") {
      scroller.scrollTo(section, {
        duration: 600,
        smooth: true,
        offset: -80,
      });
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  const goHomeMode = () => {
    toggleSidebar(false);
    navigate("/");
  };

  const goToAdmin = () => {
    toggleSidebar(false);
    navigate("/services");
  };

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <div style={{ textAlign: "center" }}>
            <img
              src="/nava-logo.png"
              alt="Nava Energy logo"
              style={{
                width: 80,
                height: 50,
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
              loading="lazy"
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <h1 style={{ fontSize: "20px", fontWeight: "800", margin: 0, color: "#13365c" }}>NAVA</h1>
            <h2 style={{ fontSize: "14px", fontWeight: "800", margin: 0, color: "#179fd6" }}>ENERGY</h2>
          </div>
        </div>

        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer" aria-label="Close sidebar">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>
      <UlStyle className="flexNullCenter flexColumn" role="menu">
        {mode === "home" ? (
          <>
            <li className="semiBold font15 pointer" role="none">
              <button
                role="menuitem"
                onClick={() => handleNavTo("home")}
                className="whiteColor"
                style={{ padding: "10px 15px", border: 0, background: "transparent", cursor: "pointer", textAlign: "left" }}
              >
                Home
              </button>
            </li>

            <li className="semiBold font15 pointer" role="none">
              <button
                role="menuitem"
                onClick={() => handleNavTo("projects")}
                className="whiteColor"
                style={{ padding: "10px 15px", border: 0, background: "transparent", cursor: "pointer", textAlign: "left" }}
              >
                Admin
              </button>
            </li>

            <li className="semiBold font15 pointer" role="none">
              <button
                role="menuitem"
                onClick={() => handleNavTo("contact")}
                className="whiteColor"
                style={{ padding: "10px 15px", border: 0, background: "transparent", cursor: "pointer", textAlign: "left" }}
              >
                Contact
              </button>
            </li>
          </>
        ) : (
          <>
            <li className="semiBold font15 pointer" role="none">
              <button
                role="menuitem"
                onClick={() => handleNavTo("my-services")}
                className="whiteColor"
                style={{ padding: "10px 15px", border: 0, background: "transparent", cursor: "pointer", textAlign: "left" }}
              >
                My Services
              </button>
            </li>

            <li className="semiBold font15 pointer" role="none">
              <button
                role="menuitem"
                onClick={() => handleNavTo("client-messages")}
                className="whiteColor"
                style={{ padding: "10px 15px", border: 0, background: "transparent", cursor: "pointer", textAlign: "left" }}
              >
                Client Messages
              </button>
            </li>
          </>
        )}
      </UlStyle>
      <UlStyle className="flexSpaceCenter">
        {mode === "home" ? (
          <>
            <li className="semiBold font15 pointer">
              <a href="/" style={{ padding: "10px 30px 10px 0" }} className="whiteColor">
                Log in
              </a>
            </li>
            <li className="semiBold font15 pointer flexCenter">
              <RouterLink to="/services" className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                Admin
              </RouterLink>
            </li>
            {/* <li className="semiBold font15 pointer flexCenter">
              <RouterLink to="/messages" className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                Messages
              </RouterLink>
            </li> */}
          </>
        ) : (
          <>
            <li className="semiBold font15 pointer">
              <button
                onClick={goHomeMode}
                style={{ padding: "10px 30px 10px 0", border: 0, background: "transparent", cursor: "pointer" }}
                className="whiteColor"
              >
                Home
              </button>
            </li>
            <li className="semiBold font15 pointer flexCenter">
              <a href="/" className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                Log in
              </a>
            </li>
          </>
        )}
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;

  @media (max-width: 400px) {
    width: calc(100% - 56px);
  }
`;

const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
